import { render, staticRenderFns } from "./SimulationsLegacyTab.vue?vue&type=template&id=73ba7d98&scoped=true&"
import script from "./SimulationsLegacyTab.vue?vue&type=script&lang=js&"
export * from "./SimulationsLegacyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ba7d98",
  null
  
)

export default component.exports